import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '@environments/environment.style';
import { BookedTrip, Flight, PassengerFlightInfo } from '@ibe/models';
import { BookingService, INDRAMybService, MybService } from '@ibe/services';
import { SidebarService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import * as _ from 'lodash';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import * as fromStore from '../../../../../store';
import * as BookedTripActions from '@ibe/store/actions/booked-trip.actions';
import { FeaturesMap } from '@ibe.models/flight.model.lib';
//import { PACK1, PACK2, PACK3, WIFI_ONBOARD, brandExtraFeature, getBrandFeatures, getPackFeatures, getPacks, packFeature } from '@ibe.components/booking/flights/brand/brand';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { PaymentService } from '@ibe.components/shared/payment/payment.service';
import { ANCILLARY_GROUP_MUSIC_INSTRUMENT_LIST, ANCILLARY_GROUP_SPORTS_EQUIPMENT_LIST, ANCILLARY_PRODUCT_PACKS, EXTRAS_ANCILLARY_PACK, EXTRAS_ANCILLARY_SEAT_SSR, SSR_CODE_FAST_TRACK, SSR_CODE_MUSIC_INSTRUMENT_LARGE, SSR_CODE_MUSIC_INSTRUMENT_MEDIUM, SSR_CODE_MUSIC_INSTRUMENT_SMALL, SSR_CODE_SPORTS_EQUIPMENT_BIKE, SSR_CODE_SPORTS_EQUIPMENT_FISH, SSR_CODE_SPORTS_EQUIPMENT_GOLF, SSR_CODE_SPORTS_EQUIPMENT_HANG_GLIDER, SSR_CODE_SPORTS_EQUIPMENT_KITE, SSR_CODE_SPORTS_EQUIPMENT_LONG_BOARD, SSR_CODE_SPORTS_EQUIPMENT_PARAGLIDER, SSR_CODE_SPORTS_EQUIPMENT_POLE_VAULT, SSR_CODE_SPORTS_EQUIPMENT_SCUBA, SSR_CODE_SPORTS_EQUIPMENT_SKI, SSR_CODE_SPORTS_EQUIPMENT_SKIM_BOARD, SSR_CODE_SPORTS_EQUIPMENT_SURF_BOARD, SSR_CODE_SPORTS_EQUIPMENT_WINDSURF, TRANSLATION_ANCILLARY_TEXTS, TRANSLATION_EXTRA_MUSICAL, TRANSLATION_LOUNGE, TRANSLATION_PACK, TRANSLATION_SPORTS_EQUIPMENT } from '@ibe.config';
import { INDRAAncillariesSelectionService } from '@ibe.services/ancillaries-selection.indra.service';
import { INDRAAncillariesShoppingCartService } from '@ibe.services/ancillaries-shopping-cart.indra.service';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { INDRABookingService } from '@ibe.services/booking.indra.service';
import { INDRACurrencyPipe } from '@ibe.services/currency.indra.pipe';
import { INDRADateService } from '@ibe.services/date.indra.service';
import { INDRAGoogleAnalyticsService } from '@ibe.services/google.analytics.indra.service';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { INDRAExtraSidebar } from '../extra-sidebar.indra.abstract';
import { INDRAFeature } from '@ibe.components/shared/flight-brand-features-list/features.indra';
import { INDRAAncillariesService } from '@ibe.services/ancillaries.indra.service';
import { INDRAPackService } from './pack.service.indra';
import { INDRAAddOnAncillary } from '@ibe.models/ancillary.indra.model.lib';
import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';
import { INDRATotalFlightPrice } from '@ibe.models/flight-price.model.indra.lib';
import { INDRABookedTripDetails, INDRAFareInformation } from '@ibe.models/booked-trip-details.indra.model.lib';

@Component({
	selector: 'app-pack',
	templateUrl: './pack.indra.component.html',
	styleUrls: ['./pack.component.scss'],
	providers: [INDRACurrencyPipe],
	host: { class: 'app-pack' }
})
export class INDRAPackComponent extends INDRAExtraSidebar implements OnInit, OnDestroy {

	currency = environment.currency;
	activeBookedTrip: INDRABookedTripDetails;

	@ViewChild('sidebar__notification') $notification: ElementRef;
	notificationShowing: boolean;
	notificationMessage: string;
	notificationDuration = 2.5; // in seconds
	lastActiveElement;

	showMeasure = false;
	seatPack = false;
	seatSelection: any = {};
	seatSubscription: Subscription;

	isMYB: boolean = false;
	isAlive = true;
	flightIdentifier: string;
	addedMesssage: string;
	selectedFeaturePrice: number;
	addedExtras: any[] = [];
	packId: string;
	flightId: string;
	isAdded: boolean;
	pack: any = [];
	packFeatures: any;
	musicAncillary: string;
	sportAncillary: string;

	otherFlights: Flight[] = [];

	booking$: Observable<BookedTrip> = this.store.select(fromStore.getSelectedBookedTrip);
	booking: BookedTrip;
	hasChanges$: Observable<any>;

	selectedStop: any;
	flightStop: any;
	directFlight: boolean = false;
	flightBasedPack: boolean = false;
	stops = [];
	isEligibleFlag: boolean = true;


	title: string;
	dimension_title: string;
	dimension_subtitle: string;
	submitted: boolean;
	formDimension: FormGroup;

	itemsCurrencyCode: string;
	paramSubscription: Subscription;

	constructor(
		sidebarService: SidebarService,
		route: ActivatedRoute,
		router: Router,
		bookingService: INDRABookingService,
		mybService: INDRAMybService,
		ibeAdminService: INDRAIbeAdminService,
		ancillariesSelectionSrv: INDRAAncillariesSelectionService,
		ancillariesShoppingCartSrv: INDRAAncillariesShoppingCartService,
		protected ancillariesService: INDRAAncillariesService,
		private bfmStorage: INDRABFMDataStorageService,
		dateService: INDRADateService,
		googleAnalytics: INDRAGoogleAnalyticsService,
		storageService: INDRAStorageService,
		store: Store<fromStore.State>,
		private ibeAdminConfigService: INDRAIbeAdminConfigService,
		protected currencyPipe: INDRACurrencyPipe,
		protected paymentInfoService: PaymentService,
		private cdr: ChangeDetectorRef,
		private packService: INDRAPackService,
		private bookingSearchService: INDRABookingSearchService,
		private fb: FormBuilder
	) {
		super(sidebarService, route, router, bookingService, mybService, ibeAdminService, ancillariesSelectionSrv, ancillariesShoppingCartSrv, EXTRAS_ANCILLARY_PACK, dateService, googleAnalytics, storageService, store, currencyPipe, paymentInfoService);
	}

	ngOnInit() {
		this.activeBookedTrip = this.bfmStorage.INDRA_getActiveBookedTrip();
        if (this.activeBookedTrip['ancillaries-data']) {
			this.itemsCurrencyCode = this.activeBookedTrip['ancillaries-data']['bundleList'].filter(bundle => bundle.ancillaryList.length && bundle.ancillaryList[0].catalog)[0].ancillaryList[0].catalog[0].passengers[0].codeList[0].currency;
		}
		this.flightCardId = this.route.snapshot.paramMap.get('flight');
		this.flight = this.bookingService.INDRA_getBookedFlight(this.flightCardId);
		this.passengers = this.bookingService.INDRA_getPaxInfo(false);
		
		this.paramSubscription = this.route.params.subscribe(params => {
			this.packId = params.packId;
			this.flightId = params.flight;
			this.isAdded = params.isAdded;
			let bundlePack = this.bfmStorage.INDRA_getAncillariesPacks().filter(pck => pck.ancillaryList[0].type == this.packId);
			if (bundlePack.length) {
				bundlePack[0].ancillaryList[0].catalog.forEach(pack => {
					if (pack.flightId == params.flight) {
						this.pack.push({
							...pack,
							itemId: bundlePack[0].ancillaryList[0].itemId,
							type: bundlePack[0].ancillaryList[0].type
						})
					}
				})
				// this.pack = {
				// 	...bundlePack[0].ancillaryList[0].catalog.filter(pck => pck.flightId == this.flightId)[0],
				// 	itemId: bundlePack[0].ancillaryList[0].itemId,
				// 	type: bundlePack[0].ancillaryList[0].type
				// };
				this.packFeatures = this.pack[0].passengers[0].codeList[0].ancillaryPackInfo.ancillaryDescription;
				// this.selectedFeaturePrice = this.pack[0].passengers[0].codeList[0].price * this.passengers.length;
				this.packFeatures.forEach((feature, index) => {
					if (index === 0) {
						this.title = this.INDRA_getFeatureLabel(feature);
					} else {
						this.title += ` + ${this.INDRA_getFeatureLabel(feature)}`
					}
				});
			}
		});

		// Fills input for segmented control radio
		for (let i = 0; i < this.flight.listSegment.length; i++) {
			const segment = this.flight.listSegment[i];
			this.stops.push({
				label: segment.departureAirport + '-' + segment.arrivalAirport,
				value: i
			});
		}

		if (!this.selectedStop) {
			this.INDRA_selectedStop(0);
		}
		this.directFlight = this.flight.listSegment.length > 1 ? false : true;
		this.flightBasedPack = this.pack.some(pack => pack.flightBased);
		this.pack.forEach(pack => {
			let result = false;
			const packAncillaries = pack.passengers[0].codeList[0].ancillaryPackInfo.ancillaryDescription;
			for (let i = 0; i < packAncillaries.length; i++) {
				let ancillary = packAncillaries[i]
				if (ANCILLARY_GROUP_SPORTS_EQUIPMENT_LIST.includes(ancillary.code)) {
					this.sportAncillary = ancillary.code;
				}
				if (ANCILLARY_GROUP_MUSIC_INSTRUMENT_LIST.includes(ancillary.code)) {
					this.musicAncillary = ancillary.code;
				}
				result = ANCILLARY_GROUP_SPORTS_EQUIPMENT_LIST.includes(ancillary.code) || ANCILLARY_GROUP_MUSIC_INSTRUMENT_LIST.includes(ancillary.code);
				if (!this.showMeasure && result) {
					this.showMeasure = true;
				}
			}
		});
		if (this.showMeasure) {
			if (this.musicAncillary && this.musicAncillary.length && this.sportAncillary && this.sportAncillary.length) {
				this.formDimension = this.fb.group({
					weightCheckInstrument: new FormControl(null, Validators.requiredTrue),
					sizeCheckInstrument: new FormControl(null, Validators.requiredTrue),
					weightCheckSport: new FormControl(null, Validators.requiredTrue),
					sizeCheckSport: new FormControl(null, Validators.requiredTrue),
				});
			} else if (this.musicAncillary && this.musicAncillary.length) {
				this.formDimension = this.fb.group({
					weightCheckInstrument: new FormControl(null, Validators.requiredTrue),
					sizeCheckInstrument: new FormControl(null, Validators.requiredTrue),
				});
			} else if (this.sportAncillary && this.sportAncillary.length) {
				this.formDimension = this.fb.group({
					weightCheckSport: new FormControl(null, Validators.requiredTrue),
					sizeCheckSport: new FormControl(null, Validators.requiredTrue),
				});
			}
		}

		this.pack.forEach(pack => {
			this.seatPack = this.seatPack || pack.passengers[0].codeList[0].ancillaryPackInfo.ancillaryDescription.some(ancillary => ancillary.code === EXTRAS_ANCILLARY_SEAT_SSR);
		});

		if (this.seatPack) {
			let pnr = this.bookingService.getCurrentPNR();
			this.seatSubscription = this.packService.packSeatSelection.subscribe(value => {
				if (value && (JSON.stringify(value) !== JSON.stringify(this.seatSelection))) {
					this.seatSelection = value;
					if (!_.isEmpty(value)) {
						// Set selected stop to first stop where seats were added
						let seatPax = Object.keys(this.seatSelection)[0];
						let seatSegment = Object.keys(this.seatSelection[seatPax])[0];
						let seatFlightStopIndex = this.flight.listSegment.findIndex(segment => JSON.stringify(segment.idInfoSegment) === seatSegment);
						if (seatFlightStopIndex >= 0) {
							this.INDRA_selectedStop(seatFlightStopIndex);	
							let packSegment = this.pack.filter(pack => pack.segmentId == this.flightStop.idInfoSegment)[0];
							this.INDRA_addSeatBundle(packSegment, pnr);
						}
					}
				}
			});
		}
	}

	ngOnDestroy(): void {
		if (this.seatPack) {
			this.seatSubscription.unsubscribe();
		}
	}

	INDRA_addBundle() {
		this.submitted = true;
		if ((this.showMeasure && this.INDRA_getErrorMessage() == null) || !this.showMeasure) {
			let pnr = this.bookingService.getCurrentPNR();
			let packSegment = this.pack.filter(pack => pack.segmentId == this.flightStop.idInfoSegment)[0];
			let addedAncillaries = []

			if (this.seatPack) {
				// Need to select seats before calling API
				this.sidebarService.openSidebar(['seatmap', { flight: this.flight.idFlight, pack: packSegment.passengers[0].codeList[0].code, packSegment: packSegment.segmentId, flightBasedPack: this.flightBasedPack}]);
			} else {
				//API Call
				this.ancillariesSelectionSrv.INDRA_doBundleSelection(packSegment, pnr, this.passengers, this.flight.listSegment, this.flightBasedPack).subscribe(result => {
					if (result.status == "200") {
						if (this.flightBasedPack) {
							this.pack.forEach(segmentPack => {
								this.packService.addPack(segmentPack);
								let packAsAncillary: any = {
									code: segmentPack.passengers[0].codeList[0].code,
									currency: segmentPack.passengers[0].codeList[0].currency,
									maxQuantity: 1,
									price: segmentPack.passengers[0].codeList[0].price,
									itemId: segmentPack.itemId,
									type: segmentPack.passengers[0].codeList[0].type,
									flightId: segmentPack.flightId,
									flightCardId: segmentPack.flightId.toString(),
									segmentId: segmentPack.segmentId,
									flightBased: segmentPack.flightBased,
									paxId: segmentPack.passengers[0].paxId,
									paxTatto: segmentPack.passengers[0].paxTattoo,
									enabled: true,
									serviceCode: segmentPack.passengers[0].codeList[0].serviceCode
								};
								
								addedAncillaries.push(packAsAncillary);
							});
						} else {
							packSegment = this.pack.filter(pack => pack.segmentId == this.flightStop.idInfoSegment)[0];

							this.packService.addPack(packSegment);
							let packAsAncillary: any = {
								code: packSegment.passengers[0].codeList[0].code,
								currency: packSegment.passengers[0].codeList[0].currency,
								maxQuantity: 1,
								price: packSegment.passengers[0].codeList[0].price,
								itemId: packSegment.itemId,
								type: packSegment.passengers[0].codeList[0].type,
								flightId: packSegment.flightId,
								flightCardId: packSegment.flightId.toString(),
								segmentId: packSegment.segmentId,
								flightBased: packSegment.flightBased,
								paxId: packSegment.passengers[0].paxId,
								paxTatto: packSegment.passengers[0].paxTattoo,
								enabled: true,
								serviceCode: packSegment.passengers[0].codeList[0].serviceCode
							};
							addedAncillaries.push(packAsAncillary);
						}
						this.storageService.set('INDRAAncillariesShoppingCartService.shoppingCart', addedAncillaries);
						this.ancillariesShoppingCartSrv.INDRA_addAncillaries(addedAncillaries);
						this.bookingSearchService.INDRA_generateTemporaryPNR().subscribe(res => {
							this.storageService.set('hasLoadedGenerate', true);
							if (res && res.data) {
								this.activeBookedTrip = new INDRABookedTripDetails(res);
								this.INDRA_setBookingTotalCost();
							}
						});
						if (this.directFlight || this.flightBasedPack) {
							this.INDRA_handleClose();
						}
					}
				});
			}
		}
	}

	INDRA_addSeatBundle(packSegment, pnr) {
		let addedAncillaries = []
		this.ancillariesSelectionSrv.INDRA_doBundleSelection(packSegment, pnr, this.passengers, this.flight.listSegment, this.flightBasedPack, this.seatSelection).subscribe(result => {
			if (result.status == "200") {
				if (this.flightBasedPack) {
					this.pack.forEach(segmentPack => {
						this.packService.addPack(segmentPack);
						let packAsAncillary: any = {
							code: segmentPack.passengers[0].codeList[0].code,
							currency: segmentPack.passengers[0].codeList[0].currency,
							maxQuantity: 1,
							price: segmentPack.passengers[0].codeList[0].price,
							itemId: segmentPack.itemId,
							type: segmentPack.passengers[0].codeList[0].type,
							flightId: segmentPack.flightId,
							flightCardId: segmentPack.flightId.toString(),
							segmentId: segmentPack.segmentId,
							flightBased: segmentPack.flightBased,
							paxId: segmentPack.passengers[0].paxId,
							paxTatto: segmentPack.passengers[0].paxTattoo,
							enabled: true,
							serviceCode: segmentPack.passengers[0].codeList[0].serviceCode,
							value: this.seatSelection[segmentPack.passengers[0].paxId][segmentPack.segmentId]
						};
						
						addedAncillaries.push(packAsAncillary);
					});
				} else {
					packSegment = this.pack.filter(pack => pack.segmentId == this.flightStop.idInfoSegment)[0];

					this.packService.addPack(packSegment);
					let packAsAncillary: any = {
						code: packSegment.passengers[0].codeList[0].code,
						currency: packSegment.passengers[0].codeList[0].currency,
						maxQuantity: 1,
						price: packSegment.passengers[0].codeList[0].price,
						itemId: packSegment.itemId,
						type: packSegment.passengers[0].codeList[0].type,
						flightId: packSegment.flightId,
						flightCardId: packSegment.flightId.toString(),
						segmentId: packSegment.segmentId,
						flightBased: packSegment.flightBased,
						paxId: packSegment.passengers[0].paxId,
						paxTatto: packSegment.passengers[0].paxTattoo,
						enabled: true,
						serviceCode: packSegment.passengers[0].codeList[0].serviceCode,
						value: this.seatSelection[packSegment.passengers[0].paxId][packSegment.segmentId]
					};
					addedAncillaries.push(packAsAncillary);
				}
				this.storageService.set('INDRAAncillariesShoppingCartService.shoppingCart', addedAncillaries);
				this.ancillariesShoppingCartSrv.INDRA_addAncillaries(addedAncillaries);
				this.bookingSearchService.INDRA_generateTemporaryPNR().subscribe(res => {
					this.storageService.set('hasLoadedGenerate', true);
					if (res && res.data) {
						this.activeBookedTrip = new INDRABookedTripDetails(res);
						this.INDRA_setBookingTotalCost();
					}
				});
				if (this.directFlight || this.flightBasedPack) {
					this.INDRA_handleClose();
				}
			}
		});
	}

	INDRA_formatCash(value) {
		let price;
		this.pack.forEach(pack => {
			if (pack.segmentId == this.flightStop.idInfoSegment) {
				price = pack.passengers[0].codeList[0].price * this.passengers.length
			}
		});


		return parseFloat(price);
	}

	featureCount(feature) {
		return 0;
	}

	INDRA_resetSubmit() {
		this.submitted = false;
	}

	INDRA_getFeatureLabel(feature) {
        return this.INDRA_getTranslation(this.ancillariesService.INDRA_getAncillaryConfig(feature.type).translation);
    }

	INDRA_getTranslation(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}

	INDRA_getErrorMessage(): string {
		const form = this.formDimension;

		return form.invalid ? 'ancillaries.bundlesSidebars.measures.required.label' : null;
	}

	// set booking total cost
	INDRA_setBookingTotalCost() {
		if (this.activeBookedTrip.data.fare.bookingTotal) {
			let miles = this.activeBookedTrip.data.fare.bookingTotal.miles && this.activeBookedTrip.data.fare.bookingTotal.miles > 0 ? this.activeBookedTrip.data.fare.bookingTotal.miles : 0;
			let cash = this.activeBookedTrip.data.fare.bookingTotal.amount ? this.activeBookedTrip.data.fare.bookingTotal.amount : 0;

			const totalPrice: INDRATotalFlightPrice = {
				cash: cash,
				miles: miles,
				currency: this.activeBookedTrip.data.fare.bookingTotal.currency
			}
			this.paymentInfoService.setTotalFlightPrice(totalPrice);
		}
	}

	INDRA_getInfoTranslation(index: number) {
		return 'ancillaries.bundlesSidebars.' + this.packId + '.info' + index;
	}

	INDRA_getConditionTranslation(index: number) {
		return 'ancillaries.bundlesSidebars.conditions.text' + index;
	}

	INDRA_getMainInfoTranslation() {
		return 'ancillaries.bundlesSidebars.' + this.packId + '.mainInfo';
	}

	INDRA_selectedStop(value) {
		if (!this.directFlight) {
			this.selectedStop = value;
			this.flightStop = this.flight.listSegment[this.selectedStop];
		}
	}

	INDRA_isPackAvailable(): boolean {
		let isPackAvailableForSegment = false;

		this.pack.forEach((pack) => {
			if (pack.segmentId === this.flightStop.idInfoSegment) {
				isPackAvailableForSegment = true
			}
		});


		return isPackAvailableForSegment;
	}

	INDRA_hasActivePackOnSegment() {
		let packIsActive = false;
		let availablePack = this.pack.find(pack => pack.segmentId === this.flightStop.idInfoSegment);
		if (availablePack) {
			let addedPack = this.ancillariesShoppingCartSrv.INDRA_getAddedAncillariesByFlightCardId(availablePack.type, availablePack.flightId);
			
			if (addedPack.length) {
				addedPack.forEach(segment => {
					if (segment.segmentId === this.flightStop.idInfoSegment) {
						packIsActive = true;
					}
				});
			}
		}
		return packIsActive; 
	}

	INDRA_getTextTranslation(lastKey: string) {
		const key = TRANSLATION_PACK + TRANSLATION_ANCILLARY_TEXTS + lastKey;
		return key;
	}

	INDRA_getTextTranslationInstrument(lastKey: string) {
		const key = TRANSLATION_EXTRA_MUSICAL + TRANSLATION_ANCILLARY_TEXTS + lastKey;
		return key;
	}

	INDRA_getTextTranslationSports(lastKey: string) {
		const key = TRANSLATION_SPORTS_EQUIPMENT + TRANSLATION_ANCILLARY_TEXTS + lastKey;
		return key;
	}

	INDRA_getLocation(code: string) {
		return this.bookingService.INDRA_getLocation(code).city;
	}

	INDRA_printAddedButtonLabel() {
		let features = [];
		let feature = [];
		let availablePack = this.pack.find(pack => pack.segmentId === this.flightStop.idInfoSegment);
		if (availablePack) {
			features =  this.ancillariesShoppingCartSrv.INDRA_getAddedAncillariesByFlightCardId(availablePack.type, availablePack.flightId);
		}
		if (features && features.length > 0) {
			feature = features.map(data => {
				if (data && data.segmentId === Number(this.flightStop.idInfoSegment)) {
					return data;
				}
			});
			feature = feature.filter(function (element) {
				return element !== undefined && element != false;
			});
		}

		return this.INDRA_getTranslation(this.ancillariesService.INDRA_getAncillaryConfig(feature[0].code).translation);
	}

	INDRA_isPackEligibleOnSegment() {
		this.isEligibleFlag = true;
		const addedAncillaries = this.ancillariesShoppingCartSrv.INDRA_getAddedAncillaries();

		addedAncillaries.forEach(ancillary => {
			if (ANCILLARY_PRODUCT_PACKS.includes(ancillary.code)) {
				// Ancillary is pack
				this.bfmStorage.INDRA_getActiveBookedTrip()['ancillaries-data'].packList.forEach(pack => {
					if (ancillary.code === pack.ancillaryList[0].type) {
						pack.ancillaryList[0].catalog[0].passengers[0].codeList[0].ancillaryPackInfo.ancillaryDescription.forEach(anc => {
							if (this.packFeatures.some(feature => feature.code === anc.code) && ancillary.segmentId === this.flightStop.idInfoSegment) {
								this.isEligibleFlag = false;
							}
						});
					}
				});

			} else {
				if (this.packFeatures.some(feature => feature.code === ancillary.code) && ancillary.segmentId === this.flightStop.idInfoSegment) {
					this.isEligibleFlag = false;
				}
			}
		});



		return this.isEligibleFlag;
	}

	INDRA_getWeightLimit(ancillary) {
		switch (ancillary) {
			case (SSR_CODE_MUSIC_INSTRUMENT_LARGE):
				return '45 Kg';
			case (SSR_CODE_MUSIC_INSTRUMENT_MEDIUM):
			case (SSR_CODE_SPORTS_EQUIPMENT_GOLF):
			case (SSR_CODE_SPORTS_EQUIPMENT_BIKE):
			case (SSR_CODE_SPORTS_EQUIPMENT_FISH):
			case (SSR_CODE_SPORTS_EQUIPMENT_SURF_BOARD):
			case (SSR_CODE_SPORTS_EQUIPMENT_LONG_BOARD):
			case (SSR_CODE_SPORTS_EQUIPMENT_KITE):
			case (SSR_CODE_SPORTS_EQUIPMENT_SKIM_BOARD):
			case (SSR_CODE_SPORTS_EQUIPMENT_HANG_GLIDER):
			case (SSR_CODE_SPORTS_EQUIPMENT_PARAGLIDER):
			case (SSR_CODE_SPORTS_EQUIPMENT_WINDSURF):
			case (SSR_CODE_SPORTS_EQUIPMENT_SCUBA):
			case (SSR_CODE_SPORTS_EQUIPMENT_SKI):
			case (SSR_CODE_SPORTS_EQUIPMENT_POLE_VAULT):
					return '32 Kg';
			case (SSR_CODE_MUSIC_INSTRUMENT_SMALL):
				return '23 Kg';
			default:
				return '45 Kg';
		}
	}

	INDRA_getHighestWeightLimit() {
		let sportWeight = 0;
		let instrumentWeight = 0;
		if (this.sportAncillary && this.sportAncillary.length) {
			sportWeight = JSON.parse(this.INDRA_getWeightLimit(this.sportAncillary).substring(0,2));
		}
		if (this.musicAncillary && this.musicAncillary.length) {
			instrumentWeight = JSON.parse(this.INDRA_getWeightLimit(this.musicAncillary).substring(0,2));
		}

		if (instrumentWeight > sportWeight) {
			return this.INDRA_getWeightLimit(this.musicAncillary);
		} else {
			return this.INDRA_getWeightLimit(this.sportAncillary);
		}
	}

	INDRA_getDimensionLimit(ancillary) {
		const upTo = this.INDRA_getTranslation(this.INDRA_getTextTranslationSports('upTo'));
		const over = this.INDRA_getTranslation(this.INDRA_getTextTranslationSports('over'));
		const sumOfDimensions = this.INDRA_getTranslation(this.INDRA_getTextTranslationSports('sumOfDimensions'));
			switch (ancillary) {
				case (SSR_CODE_SPORTS_EQUIPMENT_GOLF):
					return '175cm ' + sumOfDimensions;
				case (SSR_CODE_SPORTS_EQUIPMENT_SURF_BOARD):
				case (SSR_CODE_SPORTS_EQUIPMENT_KITE):
				case (SSR_CODE_SPORTS_EQUIPMENT_SKIM_BOARD):
				case (SSR_CODE_SPORTS_EQUIPMENT_SCUBA):
				case (SSR_CODE_SPORTS_EQUIPMENT_SKI):
					return upTo + '200cm ' + sumOfDimensions;
				case (SSR_CODE_SPORTS_EQUIPMENT_LONG_BOARD):
				case (SSR_CODE_SPORTS_EQUIPMENT_HANG_GLIDER):
				case (SSR_CODE_SPORTS_EQUIPMENT_PARAGLIDER):
				case (SSR_CODE_SPORTS_EQUIPMENT_WINDSURF):
					return upTo + '200cm ' + sumOfDimensions;
				case (SSR_CODE_SPORTS_EQUIPMENT_POLE_VAULT):
					return upTo + '235cm ' + sumOfDimensions;
				default:
					return '158cm ' + sumOfDimensions;
			}
	}
}

